module.exports = __webpack_public_path__ + "assets/58349539f3c7cecc518d259509d1896f.json";